import { BaseSyntheticEvent, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import MaskedInput from "react-maskedinput";
import DoubleBorder from "../../DoubleBorder/DoubleBorder";
import { MessageModal } from "../../MessageModal/MessageModal";
import "./ContactForm.scss";

function ContactForm(props: any) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [brand, setBrand] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    phone: false,
    brand: false,
    message: false,
  });

  useEffect(() => {
    if (window.location.search.includes("emailSent=true")) {
      setOpenModal(true);
    }
  }, []);

  const checkFormValidate = () => {
    const localErrors: any = {
      name: !name.length,
      phone: !phone.length || phone.replace(/[^0-9]/gi, "").length < 10,
      email: !email.length,
      brand: !brand.length,
      message: false,
    };

    setErrors(localErrors);

    return !Object.keys(localErrors).find((key: string) => localErrors[key]);
  };

  const handleSubmit = (event: BaseSyntheticEvent) => {
    event.preventDefault();

    if (!checkFormValidate()) {
      return false;
    } else {
      setSending(true);
      event.target.submit();
    }
  };

  const onChange = (field: string, setFunction: Function) => (element: any) => {
    setFunction(element.target.value);
    setErrors({ ...errors, [field]: false });
  };

  return (
    <div className="contact-form">
      <DoubleBorder>
        <Form
          onKeyPress={(e) => {
            e.key === "Enter" && e.preventDefault();
          }}
          className="first-section-form"
          autoComplete="off"
          action="https://formsubmit.co/6efb2602777acac3bf5ad8f71b84e4f0"
          method="POST"
          onSubmit={handleSubmit}
        >
          <input
            type="hidden"
            name="_next"
            value="https://spotregistros.com.br/?emailSent=true"
          />
          <Form.Group
            controlId="validationCustom01"
            className="form-input-group mb-3"
          >
            <Form.Control
              maxLength={60}
              type="text"
              placeholder="Nome"
              onChange={onChange("name", setName)}
              isInvalid={errors.name}
              name="Nome"
              disabled={sending}
            />
          </Form.Group>

          <Form.Group
            controlId="validationCustom02"
            className="form-input-group mb-3"
          >
            <Form.Control
              as={MaskedInput}
              mask="(11)11111-1111"
              placeholder="Telefone"
              isInvalid={errors.phone}
              onChange={onChange("phone", setPhone)}
              name="Telefone"
              disabled={sending}
            />
          </Form.Group>

          <Form.Group
            controlId="validationCustom03"
            className="form-input-group mb-3"
          >
            <Form.Control
              type="text"
              placeholder="E-mail"
              onChange={onChange("email", setEmail)}
              isInvalid={errors.email}
              name="E-mail"
              disabled={sending}
            />
          </Form.Group>

          <Form.Group
            controlId="validationCustom04"
            className="form-input-group mb-3"
          >
            <Form.Control
              type="text"
              placeholder="Nome da sua marca"
              onChange={onChange("brand", setBrand)}
              isInvalid={errors.brand}
              name="Marca"
              disabled={sending}
            />
          </Form.Group>

          <Form.Group
            controlId="validationCustom05"
            className="form-input-group mb-3"
          >
            <Form.Control
              maxLength={132}
              as="textarea"
              placeholder="Mensagem"
              onChange={onChange("message", setMessage)}
              name="Mensagem"
              disabled={sending}
            />
          </Form.Group>

          <Button className="send-buttom" type="submit">
            {!sending && <span>Enviar</span>}

            {sending && (
              <Spinner animation="border" role="status" variant="light">
                <span className="visually-hidden">Enviando...</span>
              </Spinner>
            )}
          </Button>
        </Form>
      </DoubleBorder>
      <MessageModal open={openModal} />
    </div>
  );
}

export default ContactForm;
